<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image">
				<img class="w-100 h-100" src="~@/assets/img/login-bg-10.jpg">
			</div>
			<div class="news-caption">
			<h4 class="caption-title"><b>Dimenzió</b> Önsegélyező</h4>
				<p>
					Online szállásfoglaló rendszer
				</p>
			</div>
			<div class="row" style="overflow:auto;z-index:60;height:80%;margin-top:10px;" v-if="!show_gdpr">
				<div class="col-lg-6 col-md-8 col-12 mx-auto">
					<div class="card rounded my-2" v-for="(news_item,id) in news" :key="id">
						<div class="card-body">
							<h1>{{news_item.name}}</h1>
							<img v-if="news_item.image" :src="news_item.image" class="img-fluid" style="width:100%;" />
							<p class="wrapped-new-line mt-4" v-html="news_item.description"></p>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-else>
				<div class="col-md-8 col-12 mx-auto">
					<div class="card rounded my-2">
						<div class="card-body overflow-auto" style="max-height:800px;">
							<h5 class="card-title">Adatkezelési tájékoztató – vendégházi szolgáltatás <i class="float-end fa fa-times cursor-pointer" @click="show_gdpr = false"></i></h5>
							<p class="card-text">Adatkezelő:</p>
							<p class="card-text">DIMENZIÓ Önsegélyező Egyesület</p>
							<p class="card-text">1119 Budapest, Fehérvári út 84/a.</p>
							<p class="card-text">info@dimenziobiztosito.hu</p>
							<p class="card-text">Az önsegélyező ágazat vendégházi szolgáltatás tevékenységek során megvalósuló adatkezelések célja és jogcíme:</p>
							<p class="card-text">Cél Adatkör Jogalap (GDPR hivatkozás):</p>
							<table class="table">
								<thead>
									<tr>
										<th>Cél</th>
										<th>Adatkör</th>
										<th>Jogalap</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="align-middle">Vendégház igénybe vétele (önsegélyező szolgáltatás)</td>
										<td class="align-middle">
											<p>Tagok és jogosult családtagjaik, kísérőik</p>
											<p>Természetes azonosítók</p>
											<p>Elérhetőségek</p>
											<p>A szolgáltatási igénybevételére vonatkozó adatok (helyszín, időtartam stb.)</p>
											<p>Pénzügyi teljesítés adatai</p>
										</td>
										<td class="align-middle">
											<p>6. cikk (1) bek b) - az érintettel létrejött szerződés előkészítése vagy teljesítése, illetve</p>
											<p>6. cikk (1) bek c) - jogi kötelezettség teljesítése (számviteli tv., adózási törvények)</p>
										</td>
									</tr>
								</tbody>
							</table>
							<p class="card-text">Az adatok kezelése a szolgáltatások nyújtásához és a kapcsolódó jogszabályi előírások teljsítéséhez szükséges; azok megadása nélkül a szolgáltatások nyújtása nem lehetséges.</p>
							<p class="card-text">Az adatok kezelésének időtartama: jogi kötelezettség teljesítése jogalappal kezelt adatok esetén a kötelezettség alapjául szolgáló jogszabályban meghatározott időtartam. A szerződés teljesítésével összefüggő adatkezelések esetén (beleértve a jogos érdeken alapuló adatkezelést) az adatokat a szerződés megszűnése után az általános polgári jogi elévülési időtartam elteltéig tároljuk A személyes adatok indokolatlan késedelem nélkül törlésre kerülnek, ha a fentiek szerinti bármilyen okból a kezelésük jogalapja megszűnt. Az érintetteknek joga van:  a rájuk vonatkozó adatokhoz hozzáférni,  az esetlegesen hibásan tárol adatok helyesbítését kérni,  a megadott hozzájárulást visszavonni (amely nem érinti a visszavonás előtti adatkezelés jogszerűségét). A hozzájárulás visszavonását az ügyfél maga tudja elvégezni azon a csatornán keresztül, ahol eredetileg a hozzájárulást megadta.</p>
							<p class="card-text">Joga van továbbá az érintettnek (jelentkezőnek) kérni mindazon rá vonatkozó személyes adatok törlését (vagy törlés nélküli korlátozott kezelését), amelyek esetében az adatkezelési célja teljesült vagy jogalapja megszűnt. Ugyancsak joga van az ügyfeleknek az adatkezeléssel szemben tiltakozni.</p>
							<p class="card-text">Az adatkezelés során adatfeldolgozóként informatika ügyviteli alkalmazások üzemeltetője, irattározási szolgáltató, a vendégház üzemeltetője a személyes adatokhoz a feladataik végrehajtásához szükséges mértékben, az adatkezelő kontrollja mellett hozzáférhetnek a kezelt személyes adatokhoz.</p>
							<p class="card-text">Az adatkezelés során profilozás, vagy automatizált egyedi döntés nem történik.</p>
							<p class="card-text">Az adatok tárolása mindvégig az EU-n belül történik. Az adatkezelő minden tőle elvárható intézkedést megtesz az adatok biztonsága érdekében.</p>
							<p class="card-text">Az adatkezelőhöz a fenti email címen nyújtható be panasz, tiltakozás, vagy kezdeményezhető az érintett által bármilyen jogának gyakorlása.</p>
							<p class="card-text">Hatósági panasz esetén az illetékes hatóság:</p>
							<p class="card-text">Nemzeti Adatvédelmi és Információszabadság Hatóság</p>
							<p class="card-text">1125 Budapest, Szilágyi Erzsébet fasor 22/C</p>
							<p class="card-text">www.naih.hu</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- END news-feed -->
		
		<!-- BEGIN login-container -->
		<div class="login-container bg-info">
			<!-- BEGIN login-header -->
			<div class="login-header mb-30px">
				<h1 v-if="dev == true" style="position: absolute;
  top: 0;
  left: 0;" class="d-flex justify-content-between alert alert-danger w-100"><i class="fa fa-exclamation-triangle float-start"></i><span class="text-center"><i class="fa fa-bug"></i> DEV</span><i class="fa fa-exclamation-triangle float-end"></i></h1>
				<div class="brand w-100 text-center">
					<img src="~@/assets/img/logo.png" class="img-fluid">
				</div>
			</div>
			<!-- END login-header -->
			
			<!-- BEGIN login-content -->
			<div class="login-content">
				<form @submit.prevent="login" class="fs-13px" v-if="!register">
					<div class="alert alert-info fade show" v-if="register_success">Regisztrációja sikeres volt! Mielött belépne, igazolja vissza email címét az oda kiküldött visszaigazoló gomb segítségével!</div>
					<div class="form-floating mb-15px">
						<input type="email" v-model="form.email" class="form-control h-45px fs-13px" placeholder="Email cím" id="emailAddress" />
						<label for="emailAddress" class="d-flex align-items-center fs-13px text-gray-600">E-mail cím</label>
					</div>
					<div class="form-floating">
						<input type="password" v-model="form.password" class="form-control h-45px fs-13px" placeholder="Jelszó" id="password" />
						<label for="password" class="d-flex align-items-center fs-13px text-gray-600">Jelszó</label>
					</div>
					<a :href="back_url+'/password/reset'" class="mb-15px text-decoration-none text-white"><i class="fa fa-key"></i> Elfelejtett jelszó?</a><br>
					<div class="my-15px">
						<button type="submit" class="btn btn-white d-block h-45px w-100 btn-lg fs-14px" :disabled="loading">
							<template v-if="loading">
								<i class="fa fa-cog fa-spin"></i> Tagadatok lekérdezése...
							</template>
							<template v-else>
								Belépés
							</template>
						</button>
					</div>
					<span class="text-white">Még nincs fiókja?</span><button type="button" @click="toggleRegister" class="btn btn-xs btn-info border border-white ms-2"><b>Regisztráljon</b></button>
				</form>
				<form @submit.prevent="registerSend" class="fs-13px" v-else>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" maxlength="10" v-model="register_form.membership_id" class="form-control h-45px fs-13px" placeholder="Tagazonosító" id="memberId" :class="{'is-invalid' : errors.membership_id}"/>
							<label for="memberId" class="d-flex align-items-center fs-13px text-gray-600">Tagazonosító</label>
						</div>
						<div class="badge bg-danger" v-if="errors.membership_id">
								{{ errors.membership_id[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" v-model="register_form.name" class="form-control h-45px fs-13px" placeholder="Név" id="name" :class="{'is-invalid' : errors.name}"/>
							<label for="name" class="d-flex align-items-center fs-13px text-gray-600">Név</label>
						</div>
						<div class="badge bg-danger" v-if="errors.name">
								{{ errors.name[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="date" max="2050-12-31" v-model="register_form.birth_date" class="form-control h-45px fs-13px" style="padding-top:1.365rem;" placeholder="Születési dátum" id="birth_date"  :class="{'is-invalid' : errors.birth_date}"/>
							<label for="birth_date" class="d-flex align-items-center fs-13px text-gray-600">Születési dátum</label>
						</div>
						<div class="badge bg-danger" v-if="errors.birth_date">
								{{ errors.birth_date[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="email" v-model="register_form.email" class="form-control h-45px fs-13px" placeholder="Email cím" id="remail" :class="{'is-invalid' : errors.email}"/>
							<label for="remail" class="d-flex align-items-center fs-13px text-gray-600">Email cím</label>
						</div>
						<div class="badge bg-danger" v-if="errors.email">
								{{ errors.email[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" v-model="register_form.phone" class="form-control h-45px fs-13px" placeholder="Telefonszám" id="phone" :class="{'is-invalid' : errors.phone}"/>
							<label for="phone" class="d-flex align-items-center fs-13px text-gray-600">Telefonszám</label>
						</div>
						<div class="badge bg-danger" v-if="errors.phone">
								{{ errors.phone[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="number" v-model="register_form.postal_code" class="form-control h-45px fs-13px" placeholder="Irányítószám" id="postcode" :class="{'is-invalid' : errors.postal_code}"/>
							<label for="postcode" class="d-flex align-items-center fs-13px text-gray-600">Irányítószám</label>
						</div>
						<div class="badge bg-danger" v-if="errors.postal_code">
								{{ errors.postal_code[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" v-model="register_form.city" class="form-control h-45px fs-13px" placeholder="Város" id="city" :class="{'is-invalid' : errors.city}"/>
							<label for="city" class="d-flex align-items-center fs-13px text-gray-600">Város</label>
						</div>
						<div class="badge bg-danger" v-if="errors.city">
								{{ errors.city[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" v-model="register_form.street_address" class="form-control h-45px fs-13px" placeholder="Cím" id="street_address" :class="{'is-invalid' : errors.street_address}"/>
							<label for="street_address" class="d-flex align-items-center fs-13px text-gray-600">Cím</label>
						</div>
						<div class="badge bg-danger" v-if="errors.street_address">
								{{ errors.street_address[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="text" v-model="register_form.tin" class="form-control h-45px fs-13px" placeholder="Adóazonosító" id="tin" :class="{'is-invalid' : errors.tin}"/>
							<label for="tin" class="d-flex align-items-center fs-13px text-gray-600">Adóazonosító</label>
						</div>
						<div class="badge bg-danger" v-if="errors.tin">
								{{ errors.tin[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="password" v-model="register_form.password" class="form-control h-45px fs-13px" placeholder="Jelszó" id="rPassword1" :class="{'is-invalid' : errors.password}"/>
							<label for="rPassword1" class="d-flex align-items-center fs-13px text-gray-600">Jelszó</label>
						</div>
						<div class="badge bg-danger" v-if="errors.password">
								{{ errors.password[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-floating">
							<input type="password" v-model="register_form.password_confirmation" class="form-control h-45px fs-13px" placeholder="Jelszó mégegyszer:" id="rPassword2" :class="{'is-invalid' : errors.password_confirmation}"/>
							<label for="rPassword2" class="d-flex align-items-center fs-13px text-gray-600">Jelszó mégegyszer:</label>
						</div>
						<div class="badge bg-danger" v-if="errors.password_confirmation">
								{{ errors.password_confirmation[0] }}
						</div>
					</div>
					<div class="form-group mb-15px">
						<div class="form-check">
							<input class="form-check-input" type="checkbox" id="gdpr-checkbox" v-model="register_form.gdpr" :true-value="true" :false-value="null" />
							<label class="form-check-label text-white" for="gdpr-checkbox">Elfogadom az <b class="cursor-pointer" @click="show_gdpr = true">Adatvédelmi nyilatkozatot</b></label>
						</div>
						<div class="badge bg-danger" v-if="errors.gdpr">
								{{ errors.gdpr[0] }}
						</div>
					</div>
					<div class="mb-15px">
						<button type="submit" class="btn btn-white d-block h-45px w-100 btn-lg fs-14px">Regisztráció</button>
					</div>
					<span class="text-white">Van már fiókja?</span><button type="button" @click="toggleRegister" class="btn btn-xs btn-info border border-white ms-2"><b>Lépjen be</b></button>
				</form>
				<hr class="bg-white opacity-2" />
				<div class="text-center text-gray-500-darker mb-0">
					<a href="https://k3.hu" class="text-white" style="text-decoration:none;">
						&copy; K3Net 2022
					</a>
				</div>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->
	</div>
	<!-- END login -->
</template>

<script>
import User from "../../apis/User";
import News from "../../apis/News";

export default {
	data() {
		return {
			back_url: process.env.VUE_APP_BACK_URL,
			form: {
				email: "",
				password: ""
			},
			register_form: {
				membership_id:null,
				name:null,
				birth_date:null,
				email:null,
				phone:null,
				postal_code:null,
				city:null,
				street_address:null,
				tin:null,
				password:null,
				password_confirmation:null,
				gdpr:null,
			},
			register_success:false,
			show_gdpr:false,
			loading:false,
			register:false,
			errors: [],
			news: []
		};
	},
	created(){
		//this.reset = process.env.VUE_APP_BACK_URL
		if (window.location.href.indexOf("dev") > -1) {
			this.$store.commit('updateDev',true);
		}
		News.index()
		.then(response => {
			this.news = response.data
		})
	},
	computed:{
		dev(){
			return this.$store.state.dev;
		},
	},
	methods: {
		registerSend(){
			User.register(this.register_form)
			.then(() => {
				this.register_form = {
					membership_id:null,
					name:null,
					birth_date:null,
					email:null,
					phone:null,
					postal_code:null,
					city:null,
					street_address:null,
					tin:null,
					password:null,
					password_confirmation:null,
					gdpr:false,
				}
				this.toggleRegister();
				this.register_success = true;
				this.errors = [];
			}).catch( error => {
				this.register_success = false;
				if(error.response.data.errors){
					this.errors = error.response.data.errors;
				}
			})
		},
		toggleRegister(){
			this.register = !this.register;
		},
    login() {
			this.loading = true;
			User.login(this.form)
			.then((response) => {
				localStorage.setItem("auth", "true");
				this.$store.commit('updateAuth',true);
				this.$store.commit('updateUser',response.data);
					console.log(response.data);
				return {role_id:response.data.role_id,is_complete:response.data.profile_complete,last_updated:response.data.last_updated};
			}).then(response_simple => {
				if(response_simple.role_id == 10){
					if(!response_simple.is_complete || !response_simple.last_updated){
						this.$router.push({ name: "Profile" });
					}else{
						this.$router.push({ name: "Booking" });
					}
				}
				else if(response_simple.role_id == 3){
					this.$router.push({ name: "Financial" });
				}else{
					this.$router.push({ name: "BookingIndex" });
				}
			})
			.catch(error => {
				this.$store.commit('updateUser',null);
				if(error.response.data.errors){
					this.errors = error.response.data.errors;
				}
			}).finally(() => {
				this.loading = false;
			});
		},
  }
};
</script>